import { render, staticRenderFns } from "./Unposted.vue?vue&type=template&id=2ace4e63"
import script from "./Unposted.vue?vue&type=script&lang=js"
export * from "./Unposted.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports